import chroma from 'chroma-js';

export const generateColors = numOfColors =>
  chroma.scale('Accent').colors(numOfColors);
